import { Typography } from '@/core/ui';
import { cn } from '@/lib';

export const Loading = () => (
  <div
    className={cn(
      'flex h-screen w-full items-center justify-center',
      'bg-objects bg-apple bg-cover bg-center bg-no-repeat',
    )}
  >
    <div
      className={cn(
        'w-full lg:max-w-3xl max-w-xl rounded-md bg-chalk py-56 shadow-xl',
        'flex flex-col items-center justify-center space-y-8',
      )}
    >
      <img alt='Football Logo' className='h-32 w-full' height='21' src='/logo.svg' width='100%' />
      <Typography className='text-6xl font-medium text-content1'>....</Typography>
    </div>
  </div>
);
